import { AppHeaderProps } from "./AppHeader.contract";
import { Button } from "../../ui/Button";
import { ModeSelectionRail } from "../ModeSelectionRail/ModeSelectionRail";

export function AppHeader({
  currentPage,
  currentMode,
  modeLabel,
  lastExportedAt,
  navigateToPage,
  onModeChange,
  opportunities = [],
  selectedOpportunityId,
  onOpportunitySelect,
}: AppHeaderProps & { onModeChange?: (mode: "user" | "staff" | "admin") => void }) {
  const inGuidedEntry =
    currentPage === "start" ||
    currentPage === "proof-drop" ||
    currentPage === "confirm" ||
    currentPage === "setup-base";

  return (
    <header
      className="sticky top-0 z-50 border-b border-black/10 bg-[rgba(247,245,240,0.88)] backdrop-blur-xl"
      aria-label="Primary"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-3 flex flex-wrap items-center justify-between gap-4">
        <div
          className="flex flex-col min-w-[150px] cursor-pointer"
          onClick={() => navigateToPage("start")}
        >
          <p className="font-bold text-lg leading-tight tracking-[-0.03em] text-brand-ink">
            Monyawn 🥱
          </p>
          <p className="text-[10px] uppercase tracking-[0.18em] text-brand-muted hidden lg:block">
            Opportunity workflow assistant
          </p>
        </div>

        <nav className="flex items-center gap-2 sm:gap-3" aria-label="Page navigation">
          <Button
            variant={inGuidedEntry ? "primary" : "ghost"}
            size="md"
            className="text-xs sm:text-sm"
            aria-pressed={inGuidedEntry}
            onClick={() => navigateToPage("start")}
          >
            Intake
          </Button>
          <Button
            variant={currentPage === "workspace" ? "primary" : "ghost"}
            size="md"
            className="text-xs sm:text-sm"
            aria-pressed={currentPage === "workspace"}
            onClick={() => navigateToPage("workspace")}
          >
            Workspace
          </Button>
          <Button
            variant={currentPage === "about" ? "primary" : "ghost"}
            size="md"
            className="text-xs sm:text-sm"
            aria-pressed={currentPage === "about"}
            onClick={() => navigateToPage("about")}
          >
            About
          </Button>
          <Button
            variant={currentPage === "support" ? "primary" : "ghost"}
            size="md"
            className="text-xs sm:text-sm"
            aria-pressed={currentPage === "support"}
            onClick={() => navigateToPage("support")}
          >
            Support
          </Button>
          {!inGuidedEntry && (
            <ModeSelectionRail currentMode={currentMode} onModeChange={onModeChange} />
          )}
        </nav>

        <div
          className="flex items-center gap-2 sm:gap-3 flex-wrap justify-end"
          aria-label="Session status"
        >
          {!inGuidedEntry && opportunities.length > 0 && onOpportunitySelect && (
            <select
              value={selectedOpportunityId || ""}
              onChange={(e) => onOpportunitySelect(e.target.value)}
              className="min-w-[200px] max-w-[280px] px-3 py-2 rounded-full bg-white/70 text-brand-ink text-xs font-semibold border border-black/10 focus:outline-none focus:ring-1 focus:ring-brand-accent"
              aria-label="Switch opportunity"
            >
              <option value="" disabled>
                Select an opportunity
              </option>
              {opportunities.map((opp) => (
                <option key={opp.id} value={opp.id}>
                  {opp.name}
                </option>
              ))}
            </select>
          )}
          {!inGuidedEntry && (
            <span className="px-3 py-1.5 rounded-full bg-brand-highlight/30 text-brand-accent text-[10px] font-bold tracking-[0.14em] border border-brand-accent/10 hidden md:block">
              {modeLabel}
            </span>
          )}
          {!inGuidedEntry && (
            <span className="px-3 py-1.5 rounded-full bg-brand-highlight/30 text-brand-accent text-[10px] font-bold tracking-[0.14em] border border-brand-accent/10 hidden md:block">
              {lastExportedAt ? "ZIP READY" : "EXPORT AVAILABLE"}
            </span>
          )}
        </div>
      </div>
    </header>
  );
}
